/* SPECS COLLECTIVE navigation redesign
   Loaded by sections/header.liquid when "Specs navigation redesign" is on.
   - Bar links: mirror the open mega menu onto the bar link so the underline stays while the panel is open.
   - Phone menu: open/close, tab row, second level slide-in, currency selector cloned from the announcement bar.
   The mega menus themselves (hover, panels) are still run by theme.js via the bar's .navigation--left proxy. */
(function () {
  'use strict';

  function init() {
    var hdr = document.querySelector('.sc-nav');
    if (!hdr || hdr.getAttribute('data-sc-nav-init') === '1') return;
    hdr.setAttribute('data-sc-nav-init', '1');

    var desktop = window.matchMedia('(min-width: 768px)');

    /* ---- underline follows the open panel ---- */
    var mainTier = hdr.querySelector('#main-nav .navigation__tier-1');
    var barTier = hdr.querySelector('.sc-bar__nav .navigation__tier-1');
    if (mainTier && barTier && window.MutationObserver) {
      var sync = function () {
        var m = mainTier.children, b = barTier.children;
        for (var i = 0; i < b.length; i++) {
          var open = !!(m[i] && m[i].classList.contains('navigation__item--show-children'));
          b[i].classList.toggle('is-open', open);
        }
      };
      new MutationObserver(sync).observe(mainTier, { attributes: true, subtree: true, attributeFilter: ['class'] });
      sync();
    }

    /* ---- transparent header on phone only (home page) ----
       Mirrors the theme's own rule: transparent while the announcement bar is still in view, solid once it has scrolled
       away (or always transparent if the header is not sticky). Phone widths only; desktop never gets the class. */
    var tmHeader = hdr.querySelector('.pageheader.sc-tm');
    if (tmHeader) {
      var phone = window.matchMedia('(max-width: 767.98px)');
      var section = hdr.closest('.section-header') || hdr.parentElement;
      var tmUpdate = function () {
        var on = false;
        if (phone.matches) {
          var bar = document.querySelector('.section-announcement-bar');
          var threshold = bar ? bar.offsetTop + bar.clientHeight : 0;
          var pos = getComputedStyle(section).position;
          var sticky = pos === 'sticky' || pos === '-webkit-sticky';
          on = !sticky || window.scrollY <= threshold;
        }
        tmHeader.classList.toggle('sc-tm--on', on);
      };
      tmUpdate();
      window.addEventListener('scroll', tmUpdate, { passive: true });
      window.addEventListener('resize', tmUpdate);
      window.addEventListener('load', tmUpdate);
    }

    /* ---- phone menu ---- */
    var drawer = document.getElementById('sc-drawer');
    var btn = hdr.querySelector('.sc-menu-btn');
    if (!drawer || !btn) return;
    var body = document.body;
    var footDone = false;

    function isOpen() { return body.classList.contains('sc-drawer-open'); }

    function closeSubs() {
      var subs = drawer.querySelectorAll('.sc-drawer__sub.is-on');
      for (var i = 0; i < subs.length; i++) {
        subs[i].classList.remove('is-on');
        subs[i].setAttribute('aria-hidden', 'true');
      }
      var rows = drawer.querySelectorAll('[data-sc-sub][aria-expanded="true"]');
      for (var j = 0; j < rows.length; j++) rows[j].setAttribute('aria-expanded', 'false');
    }

    function select(id) {
      var tabs = drawer.querySelectorAll('[data-sc-tab]');
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-sc-tab') === id;
        tabs[i].classList.toggle('is-on', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      var panels = drawer.querySelectorAll('[data-sc-panel]');
      for (var k = 0; k < panels.length; k++) {
        var onP = panels[k].getAttribute('data-sc-panel') === id;
        panels[k].classList.toggle('is-on', onP);
        if (onP) panels[k].scrollTop = 0;
      }
      closeSubs();
    }

    function ensureFoot() {
      if (footDone) return;
      footDone = true;
      var foot = drawer.querySelector('.sc-drawer__foot');
      var src = document.querySelector('.announcement-bar .header-disclosures');
      if (!foot || !src) return;
      var clone = src.cloneNode(true);
      var withIds = clone.querySelectorAll('[id]');
      for (var i = 0; i < withIds.length; i++) withIds[i].id = 'sc-' + withIds[i].id;
      var ariaAttrs = ['aria-controls', 'aria-describedby'];
      for (var a = 0; a < ariaAttrs.length; a++) {
        var els = clone.querySelectorAll('[' + ariaAttrs[a] + ']');
        for (var e = 0; e < els.length; e++) els[e].setAttribute(ariaAttrs[a], 'sc-' + els[e].getAttribute(ariaAttrs[a]));
      }
      foot.appendChild(clone);
      if (window.theme && theme.Disclosure && window.jQuery) {
        var discs = clone.querySelectorAll('.disclosure');
        for (var d = 0; d < discs.length; d++) {
          jQuery(discs[d]).data('disclosure', new theme.Disclosure(jQuery(discs[d])));
        }
      }
    }

    function open() {
      ensureFoot();
      body.classList.add('sc-drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      body.classList.remove('sc-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
      setTimeout(closeSubs, 350);
    }

    btn.addEventListener('click', function (evt) {
      evt.preventDefault();
      if (isOpen()) close(); else open();
    });

    drawer.addEventListener('click', function (evt) {
      var t = evt.target;
      if (t.closest('.sc-drawer__close')) { evt.preventDefault(); close(); return; }

      var tab = t.closest('[data-sc-tab]');
      if (tab) { select(tab.getAttribute('data-sc-tab')); return; }

      var row = t.closest('[data-sc-sub]');
      if (row) {
        var sub = drawer.querySelector('[data-sc-subpanel="' + row.getAttribute('data-sc-sub') + '"]');
        if (sub) {
          sub.classList.add('is-on');
          sub.setAttribute('aria-hidden', 'false');
          sub.scrollTop = 0;
          row.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      var back = t.closest('.sc-drawer__back');
      if (back) {
        var panel = back.closest('.sc-drawer__sub');
        if (panel) {
          panel.classList.remove('is-on');
          panel.setAttribute('aria-hidden', 'true');
          var opener = drawer.querySelector('[data-sc-sub="' + panel.getAttribute('data-sc-subpanel') + '"]');
          if (opener) opener.setAttribute('aria-expanded', 'false');
        }
      }
    });

    document.addEventListener('keyup', function (evt) {
      if (evt.key === 'Escape' && isOpen()) close();
    });

    desktop.addEventListener ? desktop.addEventListener('change', function (e) { if (e.matches && isOpen()) close(); })
                             : desktop.addListener(function (e) { if (e.matches && isOpen()) close(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target && evt.target.querySelector && evt.target.querySelector('.sc-nav')) init();
  });
})();
